export default "__VITE_ASSET__BNantLe8__"